"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.match");

require("core-js/modules/es.string.replace");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _cookie2 = _interopRequireDefault(require("@zz-common/zz-utils/lib/cookie"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _day2 = _interopRequireDefault(require("@zz-common/zz-utils/lib/day"));

var _client = _interopRequireDefault(require("./client"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var date = (0, _day2.default)().format('YYYY-MM-DD');

var _default = function _default(fn) {
  var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    var _window$__PAGE_META__;

    var ignoreErrors = [/HTMLHeadElement.appendChild/, /Java object/, /responseText/, /WeixinJSBridge is not defined/gi, 'WeixinJSBridge', 'top.GLOBALS', 'originalCreateNotification', 'canvas.contentDocument', /webpack/gi, 'webpack', /Error: Timeout/, /window.zhuanzhuanMApplication.executeCmd/, /window.zhuanzhuanMApplication.executeCmd is not a function/, /window.zhuanzhuanM/, /zzcallback_/, /InvalidStateError: Failed to read/, /Loading chunk /, /ResizeObserver loop/, /zzcallbackV2_/, /zzcallback/, /nbsJsBridge.logDebug/, // 开发调试工具
    /nbsJsBridge.logJsResult/, // 开发调试工具
    /nbsJsBridge.sfp is not a function/, // 开发调试工具
    /_dsbridge.call is not a function/, /nbsDOMChanged.postMessage is not a function/, /Error: timeout/, /Network Error/gi, /window.ucbrowser/, // UC浏览器插件报的问题过滤上报
    /window.MiWebViewDetector/, // 小米环境的探测器异常：window.MiWebViewDetector.onCatch is not a function
    /window.bannerNight is not a function/, // vivo 浏览器切换 夜间/日间模式
    /window.changeNetWork is not a function/, // Smartphone 切换 网络
    '数据请求中，请稍后', // Cancel: 数据请求中，请稍后---axios options请求，会被判为异常，应该以接口状态为主，因此可忽略
    /网络异常，请稍后重试/, /网络开小差了，请稍后重试/, /验证码发送频繁,请稍后重试/, /网络开小差了/, /需要登录才可以访问/, /PerformanceObserver is not defined/, /https:\/\/goo.gl\/LdLk22/, /c35 is not defined/, // 升级adapter
    /runCustomize is not defined/, // 客户端 ios webview错误
    /安卓sdk执行错误/gi, // 客户端andr webview错误
    /ResizeObserver loop limit exceeded/, // https://github.com/quasarframework/quasar/issues/2233
    'Non-Error promise rejection captured with value: cancel', // 弹窗-取消按钮，正常操作
    'Non-Error promise rejection captured with keys: message', // 此为接口（中间态）请求中：数据请求中，请稍后
    /Non-Error promise rejection captured with value: 没有操作权限/, 'Converting circular structure to JSON', // 客服端引入的听云，主要是转转安卓上报
    /Converting circular structure to JSON/, // 客服端引入的听云，主要是转转安卓上报
    /window._handleMessageFromNative/, // 找靓机侧报：window._handleMessageFromNative is not a function，提供给native使用的方法，将消息塞进h5的消息接收队列，并进行消息分发，https://sentry.zhuanspirit.com/organizations/zhuanzhuan/issues/7165090
    /Non-Error promise rejection captured with value: useRequest has caught the exception, if you need to handle the exception yourself, you can set options.throwOnError to true./, /Unexpected identifier 'TT'/, // 这种是ios webview的问题，可以先忽略；根本原因是执行js种入cookie的时候，cookie的value需要编码，视频中的报错字段个别是前端的，由金鑫进行url encode编码支持，客户端这边的只有PPU，safe-ppu两个需要编码，iOS单独进行了处理。Android没有这个问题
    /Unexpected identifier 'type'/, // 在使用cookies的时候，存对象没编码
    /Unexpected identifier 'refpagetype'/, // 在使用cookies的时候，存对象没编码
    /跨webview访问历史跟踪报错SyntaxError/, // lego 主动上报,Sentry如果近日激增类似问题，升级@zz-common/lego@6.0.12 ，根因lego里面把zzVisitStack编码了，老版本解析异常
    /vivoNewsDetailPage.getNewsReadStatus4Vivo/, // vivo环境
    /dscb\d+\s+is not defined/, // 客户端sdk回调执行问题
    /Navigation cancelled from/, // 客户端错误
    /checkGps is not defined/, // 快狗打车-客户端错误 t=94
    /titleForRightButton is not defined/, // 快狗打车-客户端错误 t=94
    /webViewDidAppear is not defined/, // 快狗打车-客户端错误 t=94
    /cordova is not defined/, // 快狗打车-客户端错误 t=94
    /backButtonClicked is not defined/, // 快狗打车-客户端错误 t=94
    /eruda is not defined/, /themeModeCallJs is not defined/, /onNightModeChanged is not defined/, /Non-Error promise rejection captured with value: overlay/, // zz-ui弹窗得取消 or 蒙层关闭 点击事件没有catch
    /processRandomSelector is not defined/, // VivoBrowser 或此浏览器的附加组件，它在查看的网页上使用自己注入的 JS 代码
    /downloadStatusCallback is not defined/, // VivoBrowser 或此浏览器的附加组件，它在查看的网页上使用自己注入的 JS 代码
    /downProgCallback is not defined/, // VivoBrowser 或此浏览器的附加组件，它在查看的网页上使用自己注入的 JS 代码
    /vivoNewsDetailPage.getNewsReadStatus4Vivo is not a function/, //获取vivo新闻详情页中某篇新闻的阅读状态
    /onNightModeChanged is not defined/, //vivo 浏览器切换 夜间/日间模式的错误
    /themeModeCallJs is not defined/, //安兔兔cookie recoveryFrom：87
    /undefined is not an object (evaluating 'window.weixinPostMessageHandlers.weixinDispatchMessage.postMessage')/, //在微信浏览器中用于发送消息的方法。它通常用于与微信客户端或嵌入网页的微信浏览器进行通信。未定义或不是对象
    /No identifiers allowed directly after numeric literal/, //在数字字面量之后不允许直接使用标识符-三方包
    /ignoreError is not defined/, //ignoreError未定义
    /activeEvent is not defined/, //Chrome Mobile WebView 69.0.3497
    /x5onSkinSwitch is not defined/, //QQBrowser/8.1 换肤
    /syncDownloadState is not defined/ //vivo原生浏览器
    ];
    var blacklistUrls = [/extensions\//i, /^chrome:\/\//i, /webappstoolbarba\.texthelp\.com\//i, /wkbrs1\.tingyun\.com\//i, /metrics\.itunes\.apple\.com\.edgesuite\.net\//i];

    var cfgMerge = _objectSpread2(_objectSpread2({}, cfg), {}, {
      ignoreErrors: [].concat(ignoreErrors, (0, _toConsumableArray2.default)((cfg === null || cfg === void 0 ? void 0 : cfg.ignoreErrors) || [])),
      blacklistUrls: [].concat(blacklistUrls, (0, _toConsumableArray2.default)((cfg === null || cfg === void 0 ? void 0 : cfg.blacklistUrls) || []))
    });

    var envProcess = process.env.NODE_ENV === 'production' ? process.env.NODE_ENV : 'testing';
    var environment = ((_window$__PAGE_META__ = window['__PAGE_META__']) === null || _window$__PAGE_META__ === void 0 ? void 0 : _window$__PAGE_META__.env) || envProcess;
    var config = Object.assign({}, {
      environment: environment,
      ignoreErrors: ignoreErrors,
      blacklistUrls: blacklistUrls,
      beforeSend: function beforeSend(event, hint) {
        var _window$__PAGE_META__2, _event$request, _event$request$url, _event$tags, _event$tags$route, _event$exception, _event$exception2, _event$exception2$val, _navigator, _navigator$userAgent, _navigator2, _navigator2$userAgent;

        var isTesting = window['__PAGE_META__'] && ((_window$__PAGE_META__2 = window['__PAGE_META__']) === null || _window$__PAGE_META__2 === void 0 ? void 0 : _window$__PAGE_META__2.env) == 'testing'; // 测试和沙箱环境不上报

        if ((event.environment !== 'production' || isTesting) && !cfg.senddev) return; // 非线上环境不上报

        var error = hint.originalException; // 过滤预渲染上报的错误

        if ((event === null || event === void 0 ? void 0 : (_event$request = event.request) === null || _event$request === void 0 ? void 0 : (_event$request$url = _event$request.url) === null || _event$request$url === void 0 ? void 0 : _event$request$url.includes('isPreRender=1')) || (event === null || event === void 0 ? void 0 : (_event$tags = event.tags) === null || _event$tags === void 0 ? void 0 : (_event$tags$route = _event$tags.route) === null || _event$tags$route === void 0 ? void 0 : _event$tags$route.includes('isPreRender=1'))) return; // 异常提示信息

        var errorMessage = error && error.message ? error.message : event.exception && event.exception.values[0] ? event.exception.values[0].value || error && error.message || '无异常' : error && error.message || '无异常'; // 无error过滤

        if (!error || !error.message || !event.exception || !((_event$exception = event.exception) === null || _event$exception === void 0 ? void 0 : _event$exception.values[0]) || !((_event$exception2 = event.exception) === null || _event$exception2 === void 0 ? void 0 : (_event$exception2$val = _event$exception2.values[0]) === null || _event$exception2$val === void 0 ? void 0 : _event$exception2$val.value)) return; // stacktrace无来源过滤

        if (event.exception && event.exception.values[0] && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames && event.exception.values[0].stacktrace.frames.length === 1) {
          var _event$exception$valu;

          if (!event.exception.values[0].stacktrace.frames[0].filename || event.exception.values[0].stacktrace.frames[0].filename === '<anonymous>' || !event.exception.values[0].stacktrace.frames[0].context || ((_event$exception$valu = event.exception.values[0].stacktrace.frames[0].context) === null || _event$exception$valu === void 0 ? void 0 : _event$exception$valu.length) === 0 || event.exception.values[0].stacktrace.frames[0].colno === 1) return;
        } // 接口报traceId，注意reject(对象)


        if (error && (0, _typeof2.default)(error) === 'object' && error.traceid && error.errMsg) {
          event.tags = _objectSpread({
            traceId: error.traceid,
            errMsg: error.errMsg
          }, event.tags || {});
          event.exception.values[0].value = "\u63A5\u53E3\u9519\u8BEF\uFF1A".concat(error.errMsg);
        } else {
          // 无stacktrace过滤，除了接口错误 /(错误A|错误B)/i
          var regx = /Non-Error promise rejection captured with keys/i;
          if (event.exception && event.exception.values[0] && !event.exception.values[0].stacktrace && regx.test(errorMessage)) return;
        } // 登录uid


        var userId = _cookie2.default.get('uid') || _cookie2.default.get('sso_uid') || 'nofound';
        var t = _cookie2.default.get('zz_t') || _cookie2.default.get('t') || '';
        var ua = ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : (_navigator$userAgent = _navigator.userAgent) === null || _navigator$userAgent === void 0 ? void 0 : _navigator$userAgent.match(/zzVersion\/(.*?)\s/)) ? (_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : (_navigator2$userAgent = _navigator2.userAgent) === null || _navigator2$userAgent === void 0 ? void 0 : _navigator2$userAgent.match(/zzVersion\/(.*?)\s/)[1] : '';
        var version = _cookie2.default.get('v') || ua;
        var errInfoObj = {
          myLevel: 'info',
          level: 'info',
          errInfo: errorMessage,
          isSendEmail: 0
        };

        if (errorMessage && (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.match(/AbortError: The operation was aborted|IndexSizeError|SecurityError|InvalidStateError|EvalError|ReferenceError|SyntaxError|TypeError|URIError|NotSupportedError|Still in CONNECTING state|is undefined|is not an object|Object doesn't support property or method|Failed to execute 'insertBefore' on 'Node'|Failed to execute 'removeChild' on 'Node'|an invalid state|Failed to load because no supported source was found|was not suitable|Can not get editor instance|Invalid string length|Unable to get property|Unexpected identifier|Cannot set properties|Cannot read properties of undefined|Cannot read property/))) {
          errInfoObj = {
            myLevel: 'warning',
            level: 'warning',
            errInfo: errorMessage,
            isSendEmail: 1
          };
        } else if (errorMessage && (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.match(/请求地址不存在|is not defined|invalid original file format|is not a function|找不到对应的指令|Cannot read properties of null｜Request failed with status code 404/))) {
          // invalid original file format 这个主要是图片格式不符合，最好做组件前置校验
          errInfoObj = {
            myLevel: 'error',
            level: 'error',
            errInfo: errorMessage,
            isSendEmail: 1
          };
        }

        var defaultTags = _objectSpread2({
          t: t,
          version: version,
          tVersion: "".concat(t, " ").concat(version),
          client: (0, _client.default)(),
          route: location.hash && location.hash.replace(/(#)([^\?]*)(\?.*)*/g, '$2') || '',
          env: environment || '未知',
          date: date,
          tel: _cookie2.default.get('tel') || '',
          uid: userId,
          errorType: '被动上报错误'
        }, errInfoObj);

        var defaultExtra = {
          cookie: _cookie2.default.get(),
          UA: navigator.userAgent
        }; // 标签

        event.tags = event.tags ? _objectSpread2(_objectSpread2({}, defaultTags), event.tags || {}) : defaultTags; // 其他数据

        event.extra = event.extra ? _objectSpread2(_objectSpread2({}, defaultExtra), event.extra || {}) : defaultExtra;

        if (error && error.message && !event.fingerprint) {
          event.fingerprint = [process.env.NODE_ENV, '被动上报错误', error && error.message];
        }

        event.message = error && error.message;
        return event;
      }
    }, cfgMerge);

    if (fn) {
      fn(config);
    }
  } catch (err) {
    console.warn(err);
  }
};

exports.default = _default;